import React from 'react'

const Modal = ({children, primaryButtonLabel, primaryButtonOnClick, primaryButtonClass='btn-primary', secondaryButtonLabel, secondaryButtonOnClick, secondaryButtonClass='btn-secondary'}) => {

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center">
                {children}
                <div className="pt-3">
                    <button onClick={primaryButtonOnClick} type="button" className={`btn ${primaryButtonClass} mr-2`}>
                        {primaryButtonLabel}
                    </button>
                    <button onClick={secondaryButtonOnClick} type="button" className={`btn ${secondaryButtonClass} mr-2`}>
                        {secondaryButtonLabel}
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Modal